import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
import { formatBreakpointMods } from '../../helpers/util';
export var DataListAction =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataListAction, _React$Component);

  function DataListAction() {
    var _this;

    _classCallCheck(this, DataListAction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataListAction).apply(this, arguments));
    _this.state = {
      isOpen: false
    };

    _this.onToggle = function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    };

    _this.onSelect = function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    return _this;
  }

  _createClass(DataListAction, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          visibility = _a.visibility,
          id = _a.id,
          ariaLabel = _a['aria-label'],
          ariaLabelledBy = _a['aria-labelledby'],
          props = __rest(_a, ["children", "className", "visibility", "id", 'aria-label', 'aria-labelledby']);

      return React.createElement("div", Object.assign({
        className: css(styles.dataListItemAction, formatBreakpointMods(visibility, styles), className)
      }, props), children);
    }
  }]);

  return DataListAction;
}(React.Component);